module.exports = __webpack_public_path__ + "media/images/icons/medbriefcase-248626b928c5cbbcd8e2dea2b6e37b86.svg";